import { Material } from "../Material/Material.type";
import { MaterialRequisition } from "../MaterialRequisition/MaterialRequisition.type";
import { Store } from "../Store/Store.type";
import { User } from "../User/User.type";
import { ApiCallState, PagedData } from "../Utils";

export type InterStoreTransfer = {
    id: number;
    date: string;
    material_requisition_id: number;
    store_id:number;
    to_store_id:number;
    courier_name: string;
    plate_no: string;
    courier_phone: string;
    requested_by_id: number;
    approved_by_id: number;
    issued_by_id: number;

    material_requisition: MaterialRequisition;
    requested_by: User;
    approved_by: User;
    issued_by: User;
    store:Store;
    to_store:Store;
    inter_store_transfer_items: InterStoreTransferItem[];
    inter_store_transfer_statuses: InterStoreTransferStatus[];
};

export type InterStoreTransferItem = {
    id: number;
    inter_store_transfer_id: number;
    material_id: number;
    unit_price:number;
    instock_quantity: number;
    quantity: number;
    approved_quantity: number;
    remark: string;
    material: Material;
}

export type InterStoreTransferStatus = {
    id: number;
    inter_store_transfer_id: number;
    type: "View" | "Check" | "Approve";
    status: number;
    assigned_by: number;
    user_id: number;
    readonly updatedAt: Date;
};

export type InterStoreTransferStateTypes = {
    fetchAll: ApiCallState<InterStoreTransfer[]>;
    fetchPaged: ApiCallState<PagedData<InterStoreTransfer[]>>;
    fetchOne: ApiCallState<InterStoreTransfer | {}>;
};

export const InterStoreTransferActionTypes = {
    FETCH_ALL_INTER_STORE_TRANSFER: "FETCH_ALL_INTER_STORE_TRANSFER",
    FETCH_ALL_INTER_STORE_TRANSFER_RESET: "FETCH_ALL_INTER_STORE_TRANSFER_RESET",
    FETCH_ALL_INTER_STORE_TRANSFER_FAILURE: "FETCH_ALL_INTER_STORE_TRANSFER_FAILURE",
    FETCH_ALL_INTER_STORE_TRANSFER_SUCCESS: "FETCH_ALL_INTER_STORE_TRANSFER_SUCCESS",

    FETCH_ONE_INTER_STORE_TRANSFER: "FETCH_ONE_INTER_STORE_TRANSFER",
    FETCH_ONE_INTER_STORE_TRANSFER_RESET: "FETCH_ONE_INTER_STORE_TRANSFER_RESET",
    FETCH_ONE_INTER_STORE_TRANSFER_FAILURE: "FETCH_ONE_INTER_STORE_TRANSFER_FAILURE",
    FETCH_ONE_INTER_STORE_TRANSFER_SUCCESS: "FETCH_ONE_INTER_STORE_TRANSFER_SUCCESS",

    FETCH_PAGED_INTER_STORE_TRANSFER: "FETCH_PAGED_INTER_STORE_TRANSFER",
    FETCH_PAGED_INTER_STORE_TRANSFER_RESET: "FETCH_PAGED_INTER_STORE_TRANSFER_RESET",
    FETCH_PAGED_INTER_STORE_TRANSFER_FAILURE: "FETCH_PAGED_INTER_STORE_TRANSFER_FAILURE",
    FETCH_PAGED_INTER_STORE_TRANSFER_SUCCESS: "FETCH_PAGED_INTER_STORE_TRANSFER_SUCCESS",
};
